import JsComponent from '../jsComponent/jsComponent.js';
import debounce from 'lodash/debounce';

class Header extends JsComponent {
  constructor(mainElement, name = 'header') {
    super(mainElement, name);
    this.createClassNames(
      '__wrapper',
      '__sticky',
      '__sticky--active',
      '__search-icon',
      '--search-active'
    );

    if (document.querySelector('.native-app')) {
      return;
    }

    this.stickyEnabled = this.mainElement.dataset.stickyEnabled ? JSON.parse(this.mainElement.dataset.stickyEnabled) : true;

    if (this.stickyEnabled) {
      this.layoutElement = document.querySelector('.page-main');
      this.stickyElement = this.mainElement.querySelector(`.${this.classNames.sticky}`);
      this.stickyIsActive = false;
      if (this.stickyElement) {
        this.pageMainElementTop = Math.round(this.stickyElement.getBoundingClientRect().height);
      }
      this.headerStickyToggler();
      this.windowResizeHandlerDobunced = debounce(this.windowResizeHandler.bind(this), 100);
      window.addEventListener('resize', this.windowResizeHandlerDobunced);
    }

    this.bindEvents();
    this.isScrollHandlerActive = true;
  }

  getWindowScrollPos() {
    return window.pageYOffset;
  }

  bindEvents() {
    if (this.stickyEnabled) {
      const scrollHandler = this.windowScrollHandler.bind(this);
      window.addEventListener('scroll', debounce(scrollHandler, 25, {
        maxWait: 50
      }));
    }
    const searchIcon = this.mainElement.querySelector(`.${this.classNames.searchIcon}`);
    if (searchIcon) {
      searchIcon.addEventListener('click', this.toggleSearch.bind(this));
    }
  }

  windowResizeHandler() {
    if (this.stickyElement) {
      this.pageMainElementTop = Math.round(this.stickyElement.getBoundingClientRect().height);
    }
  }

  windowScrollHandler() {
    this.headerStickyToggler();
    if (this.isSearchActive() && this.isScrollHandlerActive) {
      if (this.isSuggestActive()) {
        this.mainElement.querySelector('.search-autosuggest__input input').blur();
      } else {
        this.toggleSearch();
      }
    }
  }

  headerStickyToggler() {
    const windowScrollPos = this.getWindowScrollPos();

    if (windowScrollPos > this.pageMainElementTop && !this.stickyIsActive) {
      this.activateStickyPos();
    } else if (windowScrollPos <= this.pageMainElementTop && this.stickyIsActive) {
      this.deactivateStickyPos();
    }
  }

  activateStickyPos() {
    this.stickyIsActive = true;
    this.stickyElement.classList.add(this.classNames.stickyActive);
    this.layoutElement.style.paddingTop = this.pageMainElementTop + 'px';
    this.layoutElement.classList.add('page-main--sticky-active');
  }

  deactivateStickyPos() {
    this.stickyIsActive = false;
    this.stickyElement.classList.remove(this.classNames.stickyActive);
    this.layoutElement.style.paddingTop = '0';
    this.layoutElement.classList.remove('page-main--sticky-active');
  }

  toggleSearch() {
    this.mainElement.classList.toggle(this.classNames.searchActive);
    if (this.isSearchActive()) {

      // In some cases mobile browsers scroll to the focused input field,
      // which would close our search. Deactivate our behavior for a short time to prevent this.
      this.isScrollHandlerActive = false;
      setTimeout(() => {
        this.isScrollHandlerActive = true;
      }, 1000);

      // Put focus on search field
      this.mainElement.querySelector('.input__field').focus();
    }
  }

  isSearchActive() {
    return this.mainElement.classList.contains(this.classNames.searchActive);
  }

  isSuggestActive() {
    return !!this.mainElement.querySelector('.search-autosuggest__suggestions-flyout');
  }
}

export default Header;
